import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import StickyCta from "@/components/landing/StickyCta";
import SEO from "@/components/SEO";

const StatsBar = lazy(() => import("@/components/landing/StatsBar"));
const HowItWorks = lazy(() => import("@/components/landing/HowItWorks"));
const AiMessagePicker = lazy(() => import("@/components/landing/AiMessagePicker"));
const PricingSection = lazy(() => import("@/components/landing/PricingSection"));
const FaqSection = lazy(() => import("@/components/landing/FaqSection"));
const CtaBanner = lazy(() => import("@/components/landing/CtaBanner"));
const Footer = lazy(() => import("@/components/landing/Footer"));

const SectionFallback = () => <div className="h-32" />;

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    { q: "Can recipients tell the message was written by AI?", a: "No. You give Speshly the context — relationship, shared memories, tone — and edit freely before sending. Every message reads like you wrote it on a thoughtful Sunday morning." },
    { q: "What's included in the 7-day free trial?", a: "Full Premium access: 100 credits, unlimited contacts, group send, AI gift suggestions, and holiday Special Editions. No credit card required to start, and you can cancel anytime in one click." },
    { q: "What counts as a credit?", a: "One credit equals one card sent. Thank-you replies use one credit each. Free gives you 5 starter credits to try Speshly (one-time, no monthly refill). Premium includes 100 every month." },
    { q: "What's the difference between Free and Premium?", a: "Free is a one-time taster — 5 starter credits and up to 5 contacts so you can see Speshly in action. When those run out you can start the 7-day Premium trial (no card) or upgrade. Premium unlocks unlimited contacts, group send, holiday Special Editions, AI gift suggestions, and 100 credits every month — for A$5.99/month or A$49/year." },
    { q: "Will it actually send on the right day?", a: "Yes. Cards dispatch at 8:00 AM AEST on the date you choose. You can preview, edit, or pause anything before it goes out." },
    { q: "What if I forget to add an occasion?", a: "Speshly auto-detects upcoming birthdays from your contacts and surfaces Australian public holidays in advance, so you'll always get a heads-up before the date." },
    { q: "Can I cancel anytime?", a: "Yes — one click in settings. There are no contracts, and you keep your free credits and contacts." },
    { q: "Is my contact data safe?", a: "Your contacts are private to your account, encrypted in transit, and never sold or shared. Delete your account anytime to remove all your data." },
  ].map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};

const Index = () => (
  <div className="min-h-screen">
    <SEO />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
    </Helmet>
    <Navbar />
    <HeroSection />
    <Suspense fallback={<SectionFallback />}>
      <StatsBar />
    </Suspense>
    <Suspense fallback={<SectionFallback />}>
      <HowItWorks />
    </Suspense>
    <Suspense fallback={<SectionFallback />}>
      <AiMessagePicker />
    </Suspense>
    <Suspense fallback={<SectionFallback />}>
      <PricingSection />
    </Suspense>
    <Suspense fallback={<SectionFallback />}>
      <FaqSection />
    </Suspense>
    <Suspense fallback={<SectionFallback />}>
      <CtaBanner />
    </Suspense>
    <Suspense fallback={<SectionFallback />}>
      <Footer />
    </Suspense>
    <StickyCta />
  </div>
);

export default Index;
